module.exports = __webpack_public_path__ + "static/media/hire.500da5c1.svg";